import script from "./benefits.vue?vue&type=script&setup=true&lang=js"
export * from "./benefits.vue?vue&type=script&setup=true&lang=js"

import "./benefits.vue?vue&type=style&index=0&id=534b4442&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-534b4442"]])

export default __exports__